import { RightTooltip } from 'ui/tooltip';
import { SES_ACCOUNT_NAME, ITERABLE } from '../../constants';
import { IntegrationCard } from './IntegrationCard';
import { Ul } from './styled';

export const SESIntegrationCard = () => (
  <IntegrationCard sendingPlatform={ITERABLE}>
    <RightTooltip
      tooltipContent={
        <Ul>
          <li>{SES_ACCOUNT_NAME}</li>
        </Ul>
      }
      isUnderlined
    >
      1 account
    </RightTooltip>
  </IntegrationCard>
);
